import React from 'react';
import { CTAButton } from '../CTAButton';
import { VolumeFan } from '../VolumeFan';

/** Final real purchase CTA. `#final-cta` hides the mobile sticky bar while visible. */
export function FinalCta() {
  return <section aria-labelledby="final-title" className="border-t border-line bg-paper py-12 sm:py-20" data-id="element-178" data-mp="1nnybsszfdnkr">
      <div className="mx-auto w-full max-w-4xl px-5 text-center sm:px-8" data-id="element-179" data-mp="1sn173lplsffj">
        <span className="mx-auto block h-px w-10 bg-ember" aria-hidden data-id="element-180" data-mp="1ens1th2xr5qc" />
        <h2 id="final-title" className="mt-6 font-display text-[1.95rem] leading-[1.1] text-ink sm:text-[2.8rem] lg:text-[3.3rem]" data-id="element-181" data-mp="1eqnyl231rod7">
          Start Your Next Client Catio Project with a Plan
        </h2>
        <p className="mt-3 text-[1.05rem] font-medium text-graphite sm:text-[1.2rem]" data-id="element-182" data-mp="19ooyc12lt7kh">
          40 designs. Five categories. Commercial build rights included.
        </p>

        <div className="-mx-3 mt-7 sm:mx-auto sm:mt-9 sm:max-w-2xl" data-id="element-183" data-mp="3437xbtnxssxr">
          <VolumeFan data-id="element-184" data-mp="342gdfg3pcjnb" />
        </div>

        <CTAButton id="final-cta" label="Get CATIO READY™ — US$27" size="lg" className="mt-7 w-full sm:w-auto sm:px-12" data-id="element-185" data-mp="28v5a9cprsi9" />
        <p className="label-tech mt-4 text-graphite" data-id="element-186" data-mp="3tdbq34hedpbu">One-time payment · Instant digital access</p>
      </div>
    </section>;
}